export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_04.a66d23b5.jpg";